var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGovernanceTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53172 12.8026L13.5834 6.75093L12.0987 5.25454L7.53172 9.82156L5.29803 7.58787L3.81342 9.08426L7.53172 12.8026ZM8.73372 17.4674C7.51813 17.4674 6.3799 17.2385 5.319 16.7808C4.25811 16.323 3.33528 15.7017 2.5505 14.9169C1.76573 14.1322 1.14446 13.2093 0.686674 12.1484C0.228891 11.0875 0 9.9493 0 8.73372C0 7.51813 0.228891 6.3799 0.686674 5.319C1.14446 4.25811 1.76573 3.33528 2.5505 2.5505C3.33528 1.76573 4.25811 1.14446 5.319 0.686673C6.3799 0.228891 7.51813 0 8.73372 0C9.9493 0 11.0875 0.228891 12.1484 0.686673C13.2093 1.14446 14.1322 1.76573 14.9169 2.5505C15.7017 3.33528 16.323 4.25811 16.7808 5.319C17.2385 6.3799 17.4674 7.51813 17.4674 8.73372C17.4674 9.9493 17.2385 11.0875 16.7808 12.1484C16.323 13.2093 15.7017 14.1322 14.9169 14.9169C14.1322 15.7017 13.2093 16.323 12.1484 16.7808C11.0875 17.2385 9.9493 17.4674 8.73372 17.4674Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernanceTickIcon);
export default __webpack_public_path__ + "static/media/GovernanceTickIcon.1f6241b8cf4ed46b3399db9fe5509522.svg";
export { ForwardRef as ReactComponent };